<!-- Stays in the form, under the control the conflict is about: one line saying
     where the field stands and the way back into the dialog. -->
<div *ngIf="conflict" class="cr-strip" [class.cr-strip--done]="chosen && !terminal"
    [class.cr-strip--blocked]="terminal">
    <svg *ngIf="chosen && !terminal" class="cr-strip__icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M13.3 4.6 6.4 11.5 2.9 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
    <svg *ngIf="!chosen || terminal" class="cr-strip__icon" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
            d="M7.5 1.25a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5Zm0 11.25a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-5.31a.63.63 0 0 0-.63.62v1.88a.63.63 0 1 0 1.26 0V7.81a.63.63 0 0 0-.63-.62Zm0-2.5a.81.81 0 1 0 0 1.62.81.81 0 0 0 0-1.62Z"
            fill="currentColor" />
    </svg>

    <span class="cr-strip__text">
        <ng-container *ngIf="chosen && !terminal && !unlink">
            {{ ('student-conflicts.resolved-' + chosen) | translate }}
        </ng-container>
        <ng-container *ngIf="unlink">{{ 'student-conflicts.limit-strip' | translate }}</ng-container>
        <ng-container *ngIf="!unlink && (!chosen || terminal)">{{ conflict?.message }}</ng-container>
    </span>

    <button *ngIf="canReopen" type="button" class="cr-strip__action" (click)="reopen()">
        {{ actionKey | translate }}
    </button>
</div>

<!-- Above the form's own modal, so a comparison of two whole records gets the
     room it needs no matter how narrow the form underneath is. -->
<div *ngIf="open && conflict" class="cr-backdrop" (click)="unlink || close()">
    <div class="cr-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
        <div class="cr-dialog__head">
            <div class="cr-dialog__heading">
                <h3 class="cr-dialog__title">{{ titleKey | translate }}</h3>
                <p class="cr-dialog__hint">{{ hintKey | translate }}</p>
            </div>
            <button type="button" class="cr-dialog__close" [disabled]="saving && unlink" (click)="close()"
                aria-label="Close">&times;</button>
        </div>

        <div class="cr-dialog__body">
            <ng-container *ngIf="unlink">
                <div *ngIf="notice" class="cr-notice" [class.cr-notice--warn]="notice === 'stale'" role="alert">
                    {{ ('student-conflicts.err-' + notice) | translate }}
                </div>
                <app-parent-limit-panel [conflict]="conflict" [resolutions]="resolutions" [updatedIds]="updatedIds"
                    [locked]="saving" (choose)="onChoose($event)" (undo)="undo.emit($event)">
                </app-parent-limit-panel>
            </ng-container>
            <app-conflict-panel *ngIf="!unlink" [conflict]="conflict" [resolutions]="resolutions" [lang]="lang"
                (choose)="onChoose($event)"></app-conflict-panel>
        </div>

        <div *ngIf="!unlink" class="cr-dialog__foot">
            <button type="button" class="cr-dialog__dismiss" (click)="close()">
                {{ 'student-conflicts.close' | translate }}
            </button>
        </div>

        <!-- S1 unlink: saved from here, in one request with the new parent -->
        <div *ngIf="unlink" class="cr-dialog__foot cr-dialog__foot--unlink">
            <span class="cr-dialog__summary">
                <ng-container *ngIf="unlinkTarget">
                    {{ 'student-conflicts.ready' | translate: { p: unlinkTarget.parent_name } }}
                </ng-container>
                <ng-container *ngIf="!unlinkTarget">{{ 'student-conflicts.pick-one' | translate }}</ng-container>
            </span>
            <button type="button" class="cr-dialog__dismiss" [disabled]="saving" (click)="close()">
                {{ 'student-conflicts.cancel' | translate }}
            </button>
            <button type="button" class="cr-dialog__primary" [disabled]="!canSave" (click)="onSave()">
                <span *ngIf="saving" class="cr-spinner" aria-hidden="true"></span>
                {{ (saving ? 'student-conflicts.saving' : 'student-conflicts.unlink-save') | translate }}
            </button>
        </div>
    </div>
</div>
